import { render, staticRenderFns } from "./layItemWin.vue?vue&type=template&id=28b01629&"
import script from "./layItemWin.vue?vue&type=script&lang=js&"
export * from "./layItemWin.vue?vue&type=script&lang=js&"
import style0 from "./layItemWin.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports